import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class HeaderHttpInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('token');
    const culture = localStorage.getItem('culture');

    let authReq: HttpRequest<any>;
    if (token) {
      authReq = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      })

      if(culture) {
        // parte de authReq para preservar o Authorization
        authReq = authReq.clone({
          setHeaders: { Culture: culture }
        })
      }

      return next.handle(authReq);
    }

    return next.handle(req);
  }

}
